enum PageMode {
    Top,
    ScrollingDown,
    ScrollingUp,
}

const win = $(window);
const body = $('body');
const breakPoint: number = 51;
let previousMode: PageMode = null;
let previousY: number = null;

const initialize = () => {
    if (body.hasClass('underSurveyBar')) {
        $(window).scroll(handleSurveyBarScroll);
        handleSurveyBarScroll();
    } else {
        $(window).scroll(handleSimpleScroll);
        handleSimpleScroll();
    }
};

const handleSimpleScroll = () => {
    const y = win.scrollTop();
    const mode = y < breakPoint ? PageMode.Top : null;

    if (mode !== previousMode) {
        if (mode === PageMode.Top) {
            $('body').removeClass('fixedHeader');
        } else {
            $('body').addClass('fixedHeader');
        }
        previousMode = mode;
    }
};

const handleSurveyBarScroll = () => {
    let mode = previousMode;
    const y = win.scrollTop();
    if (y >= breakPoint) {
        if (previousY == null || y < previousY) {
            mode = PageMode.ScrollingUp;
        } else if (y > previousY) {
            mode = PageMode.ScrollingDown;
        }
    } else {
        mode = PageMode.Top;
    }

    if (mode !== previousMode || previousMode == null) {
        switch (mode) {
            case PageMode.Top:
                body.removeClass('fixedHeader');
                body.removeClass('scrollingUp');
                body.removeClass('scrollingDown');
                break;
            case PageMode.ScrollingDown:
                body.addClass('fixedHeader');
                body.removeClass('scrollingUp');
                body.addClass('scrollingDown');
                break;
            case PageMode.ScrollingUp:
                body.addClass('fixedHeader');
                body.addClass('scrollingUp');
                body.removeClass('scrollingDown');
                break;
        }
    }
    previousMode = mode;
    previousY = y;
};

export const NavbarScroller = {
    initialize,
};
